import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Stack,
  Typography,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ArrowForward } from "@mui/icons-material";

const getColor = (value) => {
  switch (value) {
    case "High":
      return "error";
    case "Medium":
      return "warning";
    case "Moderate":
      return "success";
    default:
      return "primary";
  }
};

const RiskFactorsChart = ({ stats }) => {
  const riskFactors = stats["Risk Factors for this industry"].risk_factors;

  return (
    <Box sx={{ py: 2 }}>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: "16px",
          boxShadow: "none",
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow
              sx={{
                "& th": {
                  color: "#fff",
                  backgroundColor: "#151A27",
                  borderColor: "#151A27",
                },
              }}
            >
              <TableCell>Risk Factor</TableCell>
              <TableCell align="left">Likelihood</TableCell>
              <TableCell align="left">Potential Impact</TableCell>
              <TableCell align="left">Mitigation Strategy</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {riskFactors.map((row) => (
              <TableRow
                key={row.Risk_Factor}
                sx={{
                  "& td": {
                    color: "#fff",
                    backgroundColor: "#0E111A",
                    borderColor: "#1B212B",
                  },
                }}
              >
                <TableCell>
                  <Stack direction={"row"} alignItems={"center"} spacing={1}>
                    <Typography variant="body2">{row.Risk_Factor}</Typography>
                    <ArrowForward sx={{ color: "#6C42FA" }} />{" "}
                  </Stack>
                </TableCell>
                <TableCell align="left">
                  <Button
                    size="small"
                    variant="outlined"
                    color={getColor(row.Likelihood)}
                  >
                    {row.Likelihood}
                  </Button>
                </TableCell>
                <TableCell align="left">
                  <Button
                    size="small"
                    variant="outlined"
                    color={getColor(row.Potential_Impact)}
                  >
                    {row.Potential_Impact}
                  </Button>
                </TableCell>
                <TableCell align="left">{row.Mitigation_Strategy}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default RiskFactorsChart;
